import React from 'react';
import { WebUrlData } from '@base-configs';
import { Navigate } from 'react-router-dom';

export function TemplateFeature() {
  return <Navigate to={WebUrlData.simple_template} replace />;
}
